import {
  PatientDeleteActionTypes,
  PATIENT_DELETE_FAIL,
  PATIENT_DELETE_LOADING,
  PATIENT_DELETE_SUCCESS,
  PatientDeleteState,
  PATIENT_DELETE_API_MSG,
  PATIENT_DELETE_API_RES,
} from "./ActionTypes";
import { DeletePatientResponse } from "./Model";

const initialStateEditPosts: PatientDeleteState = {
  loading: false,
  PatientDeleteResponse: {} as DeletePatientResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const patientDeleteReducer = (
  state = initialStateEditPosts,
  action: PatientDeleteActionTypes
): PatientDeleteState => {
  switch (action.type) {
    case PATIENT_DELETE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case PATIENT_DELETE_SUCCESS:
      return {
        ...state,
        PatientDeleteResponse: action.payload,
        successMsg: action.successMsg,
      };
    case PATIENT_DELETE_FAIL:
      return {
        ...state,
        PatientDeleteResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PATIENT_DELETE_API_MSG:
      return {
        ...state,
        PatientDeleteResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PATIENT_DELETE_API_RES:
      return {
        ...state,
        PatientDeleteResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
